import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ICreateExtractTasksParams {
  targetType: string; // ExtractTaskTargetType
  targetIds: string[];
  scheduleId: string;
  type: string; // ExtractTaskType
}

export class CreateExtractTasksRequest extends Request<ICreateExtractTasksParams, IResult> {
  constructor(params: ICreateExtractTasksParams) {
    super('createExtractTasks', params);
  }
}
